function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import * as favouriteRestClient from '@shared/services/http/userFavouriteRestClient';
import { createReceiveUserFavouriteDataAction, createUpdateUserFavouriteFetchDataStatusAction, createDeleteUserFavouriteItemAction, createUpsertUserFavouriteItemAction, createFavouriteAppsPricingDataReceivedAction } from '@shared/actions/userFavouriteActions';
import { Constants } from '@shared/utils/constants';
import { shouldPerformFetchFavourite, invalidateFavourites, validateFavourites, failedDataStatus, fetchPricing } from '@shared/utils/userFavouriteThunkActionUtils';
import { SharedInstrumentService } from '@shared/services/telemetry/shared/sharedInstrument';
import { getWindow } from '@shared/services/window';
import { stringifyError } from '@shared/utils/errorUtils';
import { logger } from '@src/logger';
/**
 * fetch favourite if needed, i.e. favourite entity are invalid
 */ export function fetchUserFavourites() {
    return (dispatch, getState)=>{
        const favourite = getState().userFavourite;
        const user = getState().users;
        // if user is not signed in, we will
        // 1) skip fetching favourite
        // 2) update fetch status to invalid
        if (!user.signedIn) {
            // dispatch invalidate action only if needed
            if (favourite.fetchDataStatus !== Constants.UserFavourite.FetchDataStatus.Invalid) {
                dispatch(invalidateFavourites());
            }
            return Promise.resolve();
        }
        // if user is signed in, we will
        // 1) skip fetching favourite, if favourite in redux store is already valid, or is performing a fetch in another thread
        // 3) will fetch favourite, if favourite is invalid
        if (!shouldPerformFetchFavourite(favourite.fetchDataStatus)) {
            return Promise.resolve();
        }
        dispatch(createUpdateUserFavouriteFetchDataStatusAction({
            fetchDataStatus: Constants.UserFavourite.FetchDataStatus.IsFetching
        }));
        return favouriteRestClient.getUserFavouriteItems().then((rawUserFavourites)=>{
            dispatch(createReceiveUserFavouriteDataAction(_object_spread({}, rawUserFavourites)));
            if (getState().apps.pricingPayload) {
                dispatch(createFavouriteAppsPricingDataReceivedAction(getState().apps.pricingPayload));
            }
            dispatch(validateFavourites());
            return Promise.resolve();
        }).catch((error)=>{
            var _getWindow;
            const payload = {
                page: (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.location.href,
                action: Constants.Telemetry.Action.FetchUserFavourites,
                actionModifier: Constants.Telemetry.ActionModifier.Error,
                details: JSON.stringify({
                    error: stringifyError(error)
                })
            };
            SharedInstrumentService.getProvider().probe('logTelemetryInfo', payload);
            logger.error(payload.details, {
                action: payload.action,
                actionModifier: payload.actionModifier
            });
            dispatch(failedDataStatus());
            return Promise.resolve();
        });
    };
}
/**
 * upsert a favourite given an applicationType, i.e. add or update
 *
 * @param payload consists as same with marketplace api payload, which are
 *      applicationId: application ID of a favourite entity
 *      planId: plan ID of a favourite entity
 *      applicationType: application type of a favourite entity
 *
 * @param entityId if given, it will try to fetch pricing details to obtain its 1st plan Id, if any
 */ export function upsertUserFavourite(payload, item, entityId = undefined) {
    return (dispatch, getState)=>{
        return dispatch(fetchUserFavourites()).then(()=>{
            const favourite = getState().userFavourite;
            // skip upsertting favourite item, if favourite data is invalid
            if (favourite.fetchDataStatus === Constants.UserFavourite.FetchDataStatus.Invalid) {
                return Promise.resolve();
            }
            // upsert favourite item, if favourite data is valid
            return dispatch(fetchPricing(entityId, payload.applicationType)).then((planId)=>{
                const updatedPayload = _object_spread_props(_object_spread({}, payload), {
                    planId: planId
                });
                return favouriteRestClient.addUserFavouriteItem(updatedPayload);
            }).then((response)=>{
                const errorResponse = response;
                if (errorResponse.nonCriticalError !== Constants.UserFavourite.NotCriticalFailure.ItemExist && errorResponse.nonCriticalError !== Constants.UserFavourite.NotCriticalFailure.MaximumQuotaReached) {
                    const postResponse = response;
                    dispatch(createUpsertUserFavouriteItemAction(_object_spread_props(_object_spread({}, postResponse), {
                        item
                    })));
                    return Promise.resolve();
                }
            }).catch((error)=>{
                var _getWindow;
                const payload = {
                    page: (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.location.href,
                    action: Constants.Telemetry.Action.UpsertUserFavourite,
                    actionModifier: Constants.Telemetry.ActionModifier.Error,
                    details: JSON.stringify({
                        error: stringifyError(error)
                    })
                };
                SharedInstrumentService.getProvider().probe('logTelemetryInfo', payload);
                logger.error(payload.details, {
                    action: payload.action,
                    actionModifier: payload.actionModifier
                });
                return Promise.resolve();
            });
        }).catch((error)=>{
            var _getWindow;
            const payload = {
                page: (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.location.href,
                action: Constants.Telemetry.Action.UpsertUserFavourite,
                actionModifier: Constants.Telemetry.ActionModifier.Error,
                details: JSON.stringify({
                    error: stringifyError(error)
                })
            };
            SharedInstrumentService.getProvider().probe('logTelemetryInfo', payload);
            logger.error(payload.details, {
                action: payload.action,
                actionModifier: payload.actionModifier
            });
            return Promise.resolve();
        });
    };
}
/**
 * delete favourite
 *
 * @param entityGuid: guid generated to identify a favourite entity
 * @param applicationType: application type of a favourite entity
 */ export function deleteUserFavourite(entityGuid, applicationType) {
    return (dispatch, getState)=>{
        return dispatch(fetchUserFavourites()).then(()=>{
            const favourite = getState().userFavourite;
            // skip deleting favourite item, if favourite data is invalid
            if (favourite.fetchDataStatus === Constants.UserFavourite.FetchDataStatus.Invalid) {
                return Promise.resolve();
            }
            // delete favourite item, if favourite data is valid
            return favouriteRestClient.deleteUserFavouriteItem(entityGuid, applicationType).then((response)=>{
                if (response !== Constants.UserFavourite.NotCriticalFailure.ItemNotExist) {
                    dispatch(createDeleteUserFavouriteItemAction({
                        entityGuid: entityGuid,
                        applicationType: applicationType
                    }));
                }
                return Promise.resolve();
            }).catch((error)=>{
                var _getWindow;
                const payload = {
                    page: (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.location.href,
                    action: Constants.Telemetry.Action.DeleteUserFavourite,
                    actionModifier: Constants.Telemetry.ActionModifier.Error,
                    details: JSON.stringify({
                        error: stringifyError(error)
                    })
                };
                SharedInstrumentService.getProvider().probe('logTelemetryInfo', payload);
                logger.error(payload.details, {
                    action: payload.action,
                    actionModifier: payload.actionModifier
                });
                return Promise.resolve();
            });
        }).catch((error)=>{
            var _getWindow;
            const payload = {
                page: (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.location.href,
                action: Constants.Telemetry.Action.DeleteUserFavourite,
                actionModifier: Constants.Telemetry.ActionModifier.Error,
                details: JSON.stringify({
                    error: stringifyError(error)
                })
            };
            SharedInstrumentService.getProvider().probe('logTelemetryInfo', payload);
            logger.error(payload.details, {
                action: payload.action,
                actionModifier: payload.actionModifier
            });
            return Promise.resolve();
        });
    };
}
